<template>
  <div class="unit-subgroup-outer" v-if="selectedUnits && selectedUnits.length">
    <div class="fee-breakdown-subgroup unit-subgroup">
      <div class="unit-subgroup__head">
        <div class="unit-subgroup__code" v-if="code">{{ code }}</div>
        <div class="unit-subgroup__title">{{ title }}</div>
      </div>
      <div class="unit-subgroup__body">
        <!-- If units show unit table -->
        <template>
          <table class="table-fee-breakdown">
            <tbody>
              <FeeUnitRow
                v-for="(item, index) in selectedUnits"
                :key="item.relationship.code + '-' + index" :item="item"
                :seenUnits="seenUnits"/>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FeeUnitRow from './FeeUnitRow.vue'

export default {
  props: {
    container: {
      type: Object,
      required: false
    },
    relationship: {
      type: Object,
      required: false
    },
    location: {
      type: String,
      required: true
    },
    seenUnits: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedItemsByLocation: 'units/getSelectedCurriculumItemByLocation'
    }),
    selectedItems() {
      return this.selectedItemsByLocation(this.location) || []
    },
    selectedUnits() {
      return this.selectedItems.filter((i) => i.relationship.type === 'Unit')
    },
    title() {
      return this.container ? this.container.title : this.relationship ? this.relationship.name : ''
    },
    code() {
      return this.relationship ? this.relationship.code : ''
    }
  },
  methods: {},
  components: { FeeUnitRow }
}
</script>
